<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">


      <div class="auth-box">

        <!-- logo -->
        <div class="logo-above-auth-box logo-tenant-as-background"></div>

         <!-- content -->
         <div class="auth-box-content-wrapper">

            <h2 class="auth-box_title">{{ 'create-acc.title' | translate }}</h2>

            <form [formGroup]="form" (submit)="submitForm()" #loginForm class="page-form">

              <h3 class="page-form_title">{{ 'create-acc.client-details' | translate }}</h3>
              <div class="form-group">
                <div class="page-form_field" style="margin-bottom:0px;">
                  <input
                    type="tel"
                    formControlName="customerCode"
                    tabindex="1"
                    class="form-control"
                    id="customer-code"
                    placeholder="{{ 'create-acc.clientnumber' | translate }}" />
                  <i class="fa fa-hashtag"></i>
                </div>
                <span class="text-danger" *ngIf="formGroupDir.submitted && !form.get('customerCode').valid && !submitting">
                  {{ 'validation.required' | translate: {field: 'create-acc.clientnumber' | translate} }}
                </span>
                <p class="where-is-my-clientnumber">
                  <a href="javascript:void(0)" (click)="openModal(content)"><i class="fa fa-question-circle"></i>{{ 'create-acc.where-is-my-clientnumber' | translate }}</a>
                </p>
              </div>

              <div class="form-group" *ngIf="!userAccountNeedsValidation">
                <div class="page-form_field">
                  <input type="text" formControlName="zipCode" tabindex="2" class="form-control" id="postal-code" placeholder="{{ 'create-acc.zip' | translate }}" autocomplete="postal-code" />
                  <i class="fa fa-home"></i>
                </div>
                <span class="text-danger" *ngIf="formGroupDir.submitted && !form.get('zipCode').valid && !submitting">
                  {{ 'validation.required' | translate: {field: 'create-acc.zip' | translate} }}
                </span>
              </div>


              <h3 class="page-form_title">{{ 'create-acc.account-details' | translate }}</h3>
              <div class="form-group">
                <div class="page-form_field">
                  <input type="text" formControlName="fullname" tabindex="3" class="form-control" id="fullname" placeholder="{{ 'create-acc.fullname' | translate }}" autocomplete="name"/>
                  <i class="fa fa-user"></i>
                </div>
                <span class="text-danger" *ngIf="formGroupDir.submitted && !form.get('fullname').valid && !submitting">
                  {{ 'validation.required' | translate: {field: 'create-acc.fullname' | translate} }}
                </span>
              </div>

              <div class="form-group">
                <div class="page-form_field">
                  <input type="email" formControlName="email" class="form-control" tabindex="4" id="email" placeholder="{{ 'general.email' | translate }}" autocomplete="email"/>
                  <i class="fa fa-envelope"></i>
                </div>
                <span class="text-danger" *ngIf="formGroupDir.submitted && !form.get('email').valid && !submitting">
                  {{ 'validation.email' | translate: {field: 'login.username' | translate} }}
                </span>
              </div>

              <div class="form-group">
                <div class="page-form_field -w-legend">
                  <input type="password" formControlName="password" class="form-control" tabindex="5" id="password" placeholder="{{ 'create-acc.password' | translate }}" autocomplete="new-password"/>
                  <i class="fa fa-lock"></i>
                </div>
                <span class="page-form_legend">
                  {{'validation.passwordformatmismatch' | translate}}
                </span>
                <span class="text-danger" *ngIf="formGroupDir.submitted && !form.get('password').valid && !submitting">
                  {{ 'validation.passwordformatmismatch' | translate }}
                </span>
              </div>

              <button tabindex="6" [disabled]="submitting" class="btn btn-lg btn-success btn-block" [ngClass]="{ 'btn-run-progress' : submitting }" type="submit">
                {{ 'create-acc.submit' | translate }}
              </button>
            </form>
            <app-form-error [error]="error"></app-form-error>

            <p class="alreadyhaveanaccount">
              {{ 'create-acc.alreadyhaveanaccount' | translate }}
              <a tabindex="7" routerLink="/login">{{ 'login.title' | translate }}</a>
            </p>

          </div>
      </div>

    </div>
  </div>
</div>



<!-- Modal -->
<ng-template #content let-c="close" let-d="dismiss">
 <div class="modal-body">
    <p>
      <img [src]="clientNumberImageSrc" class="clientnumber"/>
    </p>
  </div>
</ng-template>
